<template>
    <div class="container text-left">
      <div class="row">
        <div class="col-12">
          <h2>상업화물 운송</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            기업간의 수출입 화물 FCL & LCL 취급
            수출 & 수입 통관 및 배송, VAT 대납

          </p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Commercial"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Commercial.vue